module.exports = __webpack_public_path__ + "static/Logistik-mobile-26fcf787010995e0e2a75c4dae726006.gif";